/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-23 16:52:53
 */
import ColumnTypes from '@/utils/ColumnTypes';
import auth from '@/plugins/auth';
const shopDetails = {
	key: 'shopDetails',
	label: '商品信息',
	type: ColumnTypes.MixinCell,
	fixed: 'left',
	minWidth: '300',
	showProductType: true,
	isShow: true,
};
const commission_rate = {
	key: 'commission_rate',
	label: '佣金率',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const live_price = {
	key: 'live_price',
	label: '直播价',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const sale_price = {
	key: 'sale_price',
	label: '现售价',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const service_rate = {
	key: 'service_rate',
	label: '服务费率',
	type: ColumnTypes.serviceRateCell,
	minWidth: '100',
	isShow: auth.hasPermi('system:goods-ServiceRate'),
};
const todoPromote = {
	key: 'todoPromote',
	label: '推广信息',
	type: ColumnTypes.promotionGoodsCell,
	minWidth: '160',
	isShow: true,
};
const partner_name = {
	key: 'partner_name',
	label: '招商运营',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const activity = {
	key: 'activity',
	label: '活动信息',
	type: ColumnTypes.activityCell,
	minWidth: '270',
	showTag: true,
	isShow: true,
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '100',
	fixed: 'right',
	align: 'right',
	isShow: true,
};

//抖音
export const dyColumns = [shopDetails, sale_price, live_price, commission_rate, service_rate, todoPromote, partner_name, activity, operations];
